import t from "./ghl-ui.es1669.js";
function n(f, l) {
  for (var a = 0; a < l.length; a++) {
    var e = l[a];
    e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(f, t(e.key), e);
  }
}
function u(f, l, a) {
  return l && n(f.prototype, l), a && n(f, a), Object.defineProperty(f, "prototype", {
    writable: !1
  }), f;
}
export {
  u as default
};
